import React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import ConfigCard from './ConfigCard';

/**
 * "Contact information" card. Reused anywhere a webshop's contact block is
 * shown — footer, about page, order confirmation emails…
 *
 * value shape:
 *   { shopName, tradingName, addressLine, country,
 *     phone, email, vatNumber }
 */
const ContactInformationCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb = '') => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (e) => onChange && onChange(k, e.target.value);

    return (
        <ConfigCard
            title={tr('cfg_footer_contact_title', 'Contact information')}
            description={tr('cfg_footer_contact_desc', 'Shown at the bottom of every page.')}
            theme={theme}
        >
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField size="small" label={tr('cfg_footer_contact_shop_name', 'Shop name')}    value={get('shopName')}    onChange={set('shopName')} />
                <TextField size="small" label={tr('cfg_footer_contact_trading_name', 'Trading name')} value={get('tradingName')} onChange={set('tradingName')} />
                <TextField size="small" label={tr('cfg_footer_contact_address', 'Address line')}   value={get('addressLine')} onChange={set('addressLine')} sx={{ gridColumn: { sm: '1 / -1' } }} />
                <TextField size="small" label={tr('cfg_footer_contact_country', 'Country')}        value={get('country')}     onChange={set('country')} />
                <TextField size="small" label={tr('cfg_footer_contact_vat', 'VAT number')}         value={get('vatNumber')}   onChange={set('vatNumber')} />
                <TextField size="small" label={tr('cfg_footer_contact_phone', 'Phone')}            value={get('phone')}       onChange={set('phone')} />
                <TextField size="small" label={tr('cfg_footer_contact_email', 'Email')}            type="email" value={get('email')} onChange={set('email')} />
            </Box>
        </ConfigCard>
    );
};

ContactInformationCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default ContactInformationCard;
